var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_278_202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1604 13.5898C10.5453 13.0816 9.20097 12.0742 8.34877 10.769C7.4985 9.46678 7.18655 7.94477 7.45271 6.4676C7.7192 4.98867 8.55349 3.62266 9.83576 2.62275C11.1198 1.62144 12.7644 1.05826 14.4794 1.05009C16.1944 1.04192 17.8457 1.58939 19.1417 2.57885C20.436 3.56694 21.2861 4.92552 21.5695 6.40219C21.8526 7.877 21.5579 9.40157 20.7229 10.7112C19.8861 12.0238 18.5539 13.0436 16.9451 13.567",
    stroke: "current",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7561 13.3L16.5177 13.7409C16.4103 13.7792 16.3191 13.853 16.2594 13.9502L15.0285 15.9536C15.0096 15.9844 14.9873 16.0131 14.9622 16.0392L14.0766 16.9564C13.7464 17.2984 13.1702 17.03 13.2196 16.5572L13.4202 14.6351C13.4413 14.4326 13.3375 14.2375 13.1577 14.1418L11.5753 13.3",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6207 6H17.4138",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6207 9H17.4138",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.83886 28.6266L1.46305 22.7993C1.20159 22.348 1.33093 21.7715 1.76015 21.4751L3.04656 20.5869C3.51148 20.2659 4.14983 20.3935 4.45562 20.8685L8.16219 26.627C8.46908 27.1037 8.31859 27.74 7.83065 28.0288L6.21347 28.9859C5.73505 29.2691 5.11753 29.1076 4.83886 28.6266Z",
    stroke: "current",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.86206 21.5L11.3534 20.1554C11.8455 20.0534 12.3554 20.0767 12.8361 20.2232L18.8909 22.0676C19.6607 22.3021 20.0739 23.1366 19.7938 23.891V23.891C19.5402 24.5739 18.8047 24.9474 18.1037 24.7494L14.3585 23.6915C14.1432 23.6307 13.9217 23.5942 13.6982 23.5826L12.1034 23.5",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.24133 26H8.9787C9.76676 26 10.5471 26.1552 11.2751 26.4569L14.8359 27.932C16.4704 28.6092 18.3205 28.5305 19.8915 27.7169L27.7964 23.6233C28.4911 23.2635 28.8244 22.4545 28.5847 21.7098V21.7098C28.2915 20.7987 27.2702 20.3463 26.3984 20.7413L20.3103 23.5",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_278_202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvice);
export default __webpack_public_path__ + "static/media/advice.4ac791dab5443b958d93b313002cb380.svg";
export { ForwardRef as ReactComponent };